import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import lottie from 'lottie-web';

const Error404 = () => {
    const ref = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const animator = lottie.loadAnimation({
            container: ref.current,
            animationData: require('../../Components/Animations/Error404.json'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
        });

        return () => {
            animator.destroy();
        };
    }, []);

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className='mt-8'>
            <div className="flex justify-center align-middle">
                <div ref={ref}></div>
            </div>
            <div className="flex justify-center mt-4">
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={handleGoHome}>
                    Go to Home Page
                </button>
            </div>
        </div>
    );
};

export default Error404;
